import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import '../assets/styles/Navbar.css';
import logo from '../assets/images/logo-mimina-blanco.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
    } else {
      setScrolled(false); // Si no está en la Home, el fondo es azul
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavigation = (path) => {
    handleCloseMenu();
    if (location.pathname === '/' && path.startsWith('#')) {
      const section = document.querySelector(path);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        window.history.pushState(null, '', path);
      }
    } else if (path.startsWith('#')) {
      navigate('/');
      setTimeout(() => {
        const section = document.querySelector(path);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
          window.history.pushState(null, '', path);
        }
      }, 500);
    } else {
      navigate(path);
    }
  };

  return (
    <nav
      className={`navbar-custom ${
        location.pathname === '/' && !scrolled ? 'navbar-transparent' : ''
      }`}
    >
      <div className="container-fluid container">
        <NavLink className="navbar-brand" to="/" onClick={handleCloseMenu}>
          <img
            src={logo}
            alt="Logo de mimina"
            style={{ height: '60px' }}
            className="d-inline-block align-text-top"
          />
        </NavLink>

        <button
          className="menu-toggle"
          aria-label="Abrir menú"
          onClick={handleToggleMenu}
        >
          ☰
        </button>

        <div className={`menu-container ${isMenuOpen ? 'open' : ''}`}>
          <button
            className="menu-close"
            aria-label="Cerrar menú"
            onClick={handleCloseMenu}
          >
            ✖
          </button>
          <ul className="menu-items">
            <li>
              <NavLink
                to="/"
                className="nav-link"
                onClick={() => handleNavigation('/')}
              >
                Home
              </NavLink>
            </li>
            <li>
              <button
                className="nav-link btn btn-link"
                onClick={() => handleNavigation('#nuestra-filosofia')}
              >
                Filosofía
              </button>
            </li>
            <li>
              <button
                className="nav-link btn btn-link"
                onClick={() => handleNavigation('#nuestra-propuesta')}
              >
                Propuesta
              </button>
            </li>
            <li>
              <button
                className="nav-link btn btn-link"
                onClick={() => handleNavigation('#instalaciones')}
              >
                Instalaciones
              </button>
            </li>
            <li>
              <NavLink
                to="/about"
                className="nav-link"
                onClick={() => handleNavigation('/about')}
              >
                Quiénes Somos
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className="nav-link"
                onClick={() => handleNavigation('/contact')}
              >
                Contacto
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


